<template>
    <div id="app" style="font-size: 12px;">
        <div class="line"></div>
        <table style="width: 100%;margin-top:60px;">
            <thead>
            <tr style="height:40px;background-color: #f3f4f8;border-bottom: 1px solid gainsboro;">
                <th width=5% >序号</th>
                <th width=15% >优惠券名称</th>
                <th width=20% >描述</th>
                <th width=10% >使用状态</th>
                <th width=20% >使用备注</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in tableData" style="height: 40px;border-bottom: 1px solid gainsboro;">
                <td>{{index+1}}</td>
                <td>{{item.name}}</td>
                <td>{{item.description}}</td>
                <td>
                    <span v-if="item.status == 0" style="color: red">已作废</span>
                    <span v-if="item.status == 1" style="color: blue">未使用</span>
                    <span v-if="item.status == 2" style="color: green">已使用</span>
                </td>
                <td>{{item.use_note}}</td>
            </tr>
            <tr v-if="tableData.length < 1" style="height: 40px;border-bottom: 1px solid gainsboro;">
                <td colspan="10">暂无数据</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tableData: [],
                token: '',
            }
        },
        created() {
            let that = this
            that.token = that.$cookies.get('token');
            this.get_list()
        },
        methods: {
            // 表格数据
            get_list() {
                let that = this
                $.ajax({
                    url: process.env.apiUrl + "index/coupon/gym_coupon",
                    type: "post",
                    dataType: "json",
                    data: {
                        token: that.token
                    },
                    success: function (res) {
                        that.tableData = res.data
                    }
                });
            },
        }
    }
</script>

<style scoped lang="less">
    #app {
        padding: 10px;
    }


    .line {
        position: relative;
        margin-bottom: 20px;
    }

    .line::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        border-bottom: 1px solid black;
        width: 200%;
        height: 200%;
        transform-origin: 0 0;
        transform: scale(0.5, 0.5);
        box-sizing: border-box;
    }


    table {
        th, td {
            text-align: center;
        }
    }


    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 125px;
    }

    .el-input--suffix .el-input__inner {
        padding-right: 0;
    }

    .el-table {
        flex: none;
    }

    .el-pagination {
        float: right;
    }
</style>



// WEBPACK FOOTER //
// src/pages/xitong/youhui.vue